<template>
	<section class="gallery">
		<div class="gallery-scroller scroller" :data-dir="scroller">Galerie</div>
		<div class="gallery-container" data-anim="slide">
			<div class="gallery-slides dragscroll">
				<div class="gallery-draggable">
					<div v-for="( pic, index ) in pics" :key="`gallery-item-${ index }`" class="gallery-item">
						<img :src="pic" alt="">
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import 'dragscroll'

	export default {
		name: 'Gallery',
		props: {
			scroller: String
		},
		data() {
			return {
				pics: [
					'/img/gallery_1.jpg',
					'/img/gallery_2.jpg',
					'/img/gallery_4.jpg',
					'/img/gallery_5.jpg',
                    '/img/gallery_3.jpg'
				]
			}
		}
	}
</script>